export default "__VITE_ASSET__f3ec1c01__"